import React from 'react';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export const Testimonials = () => {
  const testimonials = [{
    id: 1,
    name: 'Michael Thompson',
    position: 'CEO, TechStart',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eeSWkJ3ccUxeHDGRQefHjv/457shots_so.png',
    quote: "OTO completely transformed our product's user experience. Their designs are not only beautiful but incredibly functional. Our user engagement increased by 45% after implementing their redesign."
  }, {
    id: 2,
    name: 'Emily Rodriguez',
    position: 'Product Manager, HealthTech',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sxmxGwD5gf1F5CTGR42hgb/26_100.png',
    quote: "Working with OTO was a pleasure from start to finish. They took the time to understand our users' needs and created intuitive interfaces that perfectly aligned with our business goals."
  }, {
    id: 3,
    name: 'David Kim',
    position: 'Founder, E-commerce Platform',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gnWbTCdueQNDNp57FvRd5R/667_3x_shots_so.png',
    quote: "OTO's design work helped us stand out in a crowded marketplace. Their attention to detail and understanding of user psychology resulted in a 60% increase in conversion rates on our platform."
  }];
  return <section className="py-20 bg-indigo-50 dark:bg-gray-800 transition-colors" data-id="element-208">
      <div className="container mx-auto px-4 md:px-6" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-211">
            Client Testimonials
          </h2>
          <div className="w-20 h-1 bg-indigo-600 dark:bg-indigo-400 mx-auto mb-6" data-id="element-212"></div>
          <p className="text-gray-600 dark:text-gray-200 max-w-2xl mx-auto" data-id="element-213">
            Don't just take my word for it. Here's what my clients have to say
            about working with me.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-214">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} whileHover={{
          y: -8,
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)'
        }} className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-md relative transition-colors" data-id="element-215">
              <motion.div initial={{
            opacity: 0,
            scale: 0
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15 + 0.2
          }} className="absolute -top-4 -right-4" data-id="element-216">
                <Quote size={40} className="text-indigo-200 dark:text-indigo-900/50" data-id="element-217" />
              </motion.div>
              <div className="flex items-center mb-6" data-id="element-218">
                {[...Array(5)].map((_, i) => <motion.div key={i} initial={{
              opacity: 0,
              scale: 0
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.15 + 0.3 + i * 0.05
            }} data-id="element-219">
                    <Star size={16} className="text-yellow-400 fill-current" data-id="element-220" />
                  </motion.div>)}
              </div>
              <p className="text-gray-600 dark:text-gray-200 mb-6 italic" data-id="element-221">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-222">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center" data-id="element-223">
                  <img src={testimonial.image} alt="Dredget app design" className="w-full h-full object-cover" data-id="element-224" />
                </div>
                <div data-id="element-225">
                  <h4 className="font-bold text-gray-900 dark:text-white" data-id="element-226">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500 dark:text-gray-300" data-id="element-227">
                    {testimonial.position}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};